import React, { useEffect } from "react";

const VideoLightbox = ({ video, onClose }) => {
    if (!video) return null;


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        }
    })


    return (
        <div 
            className="video-lightbox" 
            onClick={onClose}
            role="button"
            tabIndex={0}
        >
            <div 
                className="video-lightbox__content" 
                onClick={(event) => event.stopPropagation()}
                onKeyDown={(event) => event.stopPropagation()}
                role="button"
                tabIndex={0}
            >
                <button 
                    type="button"
                    className="video-lightbox__close" 
                    onClick={onClose}
                >
                    ×
                </button>
                <video 
                    className="video-lightbox__video"
                    controls
                    autoPlay
                    muted
                >
                    <source src={video} type="video/mp4" />
                </video>
            </div>
        </div>
    );
};

export default VideoLightbox; 